import { Notifications } from "@mantine/notifications";
import { captureException, ErrorBoundary } from "@sentry/react";
import { Provider } from "react-redux";
import { Outlet } from "react-router-dom";
import ThemeWrapper from "src/components/shared/ThemeWrapper/ThemeWrapper";
import UpdateBlocker from "src/components/shared/UpdateBlocker/UpdateBlocker";
import ErrorPage from "src/pages/ErrorPage";
import { store } from "src/redux/store";
import ScrollToTop from "src/ScrollToTop";

import { useTimezoneWatcher } from "../generator/hooks/useTimezoneWatcher";
import { useLiveChat } from "./hooks";

const AppProvider = () => {
  useLiveChat();
  useTimezoneWatcher();
  const handleError = (error: unknown) => {
    captureException(error);
  };

  return (
    <ErrorBoundary fallback={<ErrorPage />} onError={handleError}>
      <Provider store={store}>
        <ThemeWrapper>
          <Notifications position="bottom-left" />
          <UpdateBlocker />
          <div className="app-container">
            <Outlet />
          </div>
          <ScrollToTop />
        </ThemeWrapper>
      </Provider>
    </ErrorBoundary>
  );
};

export default AppProvider;
